import { render, staticRenderFns } from "./TextEditorConfiguration.vue?vue&type=template&id=11926abd"
import script from "./TextEditorConfiguration.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextEditorConfiguration.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TextEditorConfiguration.vue?vue&type=style&index=0&id=11926abd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports